import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// MULTI-TENANT: provider de tenant (detecta subdomínio + carrega dados)
import { TenantProvider } from './contexts/TenantContext';
import { produtoDaUrl } from './config/produtoDaUrl';

// ─── Configuração global do React Query ─────────────────────
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:      1000 * 60 * 5, // 5 minutos
      gcTime:         1000 * 60 * 10, // 10 minutos
      retry:          2,
      refetchOnWindowFocus: false,
    },
  },
});

// Título da aba: IntegrAI CRM ou IntegrAI Entregas, conforme o endereço
document.title = produtoDaUrl().nome;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* MULTI-TENANT: TenantProvider deve envolver tudo (detecta tenant antes de renderizar) */}
    <TenantProvider>
      <QueryClientProvider client={queryClient}>
        <App />
        {/* Toast global — aparece em qualquer tela */}
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#1e293b',
              color: '#f8fafc',
              borderRadius: '10px',
              fontSize: '14px',
            },
            success: {
              iconTheme: { primary: '#22c55e', secondary: '#f8fafc' },
            },
            error: {
              iconTheme: { primary: '#ef4444', secondary: '#f8fafc' },
            },
          }}
        />
      </QueryClientProvider>
    </TenantProvider>
  </React.StrictMode>
);

reportWebVitals();
